import AppConfig from '../constants/AppConfig';
import apiClient from '../services/common/apiClient';

export default () =>
    apiClient.getJsonConfiguration('keys.json').then((keys) => {
        AppConfig.instance.setLicenseKeys(keys);
    });
